"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AvailableLanguagesExtended = exports.AvailableLanguages = exports.LocalizeActionKeys = void 0;
var LocalizeActionKeys;
(function (LocalizeActionKeys) {
    LocalizeActionKeys["Reset"] = "@localize/resetLanguage";
    LocalizeActionKeys["Select"] = "@localize/selectLanguage";
})(LocalizeActionKeys = exports.LocalizeActionKeys || (exports.LocalizeActionKeys = {}));
var AvailableLanguages;
(function (AvailableLanguages) {
    AvailableLanguages["De"] = "de";
    AvailableLanguages["Default"] = "defaults";
    AvailableLanguages["En"] = "en";
    AvailableLanguages["Sq"] = "sq";
})(AvailableLanguages = exports.AvailableLanguages || (exports.AvailableLanguages = {}));
var AvailableLanguagesExtended;
(function (AvailableLanguagesExtended) {
    AvailableLanguagesExtended["DeDE"] = "de-De";
    AvailableLanguagesExtended["En150"] = "en-150";
    AvailableLanguagesExtended["SqAL"] = "sq-AL";
})(AvailableLanguagesExtended = exports.AvailableLanguagesExtended || (exports.AvailableLanguagesExtended = {}));
